import { FunctionTypes } from '../../../components/ContributorSection/helpers';
export var NEWSLETTER_FORM_TAB_ID = 'newsletter-form-tab';
export var NEWSLETTER_FORM_TAB_TEST_ID = 'newsletter-form-tab-test';

/** newsletter citing section id and testId */
export var NEWSLETTER_CITING_SECTION_ID = 'newsletter-citing-section';
export var NEWSLETTER_CITING_SECTION_TEST_ID = 'newsletter-citing-section-test-id';

/** newsletter section input test ids */
export var NEWSLETTER_ARTICLE_TITLE_TEST_ID = 'newsletter-article-title-test-id';
export var NEWSLETTER_TITLE_TEST_ID = 'newsletter-title-test-id';
export var NEWSLETTER_DATE_PUBLISHED_TEST_ID = 'newsletter-date-published-test-id';
export var UNIQUE_KEY_FOR_FIELD = 'date-field-key';
export var NEWSLETTER_VOLUME_TEST_ID = 'newsletter-volume-test-id';
export var NEWSLETTER_PAGES_TEST_ID = 'newsletter-pages-test-id';
export var TabHeaders;
(function (TabHeaders) {
  TabHeaders["None"] = "None";
  TabHeaders["Online"] = "From a website";
  TabHeaders["OnlineDatabase"] = "Online database";
})(TabHeaders || (TabHeaders = {}));
export var NewsletterContributorFunctions = [FunctionTypes.AUTHOR, FunctionTypes.EDITOR, FunctionTypes.COMPILER, FunctionTypes.TRANSLATOR];
export var PREFIX_FOR_TEST_IDS = 'newsletter-form';
export var WEBSITE_PUB_INFO_SECTION_TITLE = 'Website publication info';
export var ONLINE_DATABASE_PUB_INFO_SECTION_TITLE = 'Online database publication info';
export var TestIds = {
  NEWSLETTER_WEBSITE_PUB_INFO_SECTION: "".concat(PREFIX_FOR_TEST_IDS, "-website-pub-info-sec-test-id"),
  NEWSLETTER_ONLINE_DATABASE_PUB_INFO_SECTION: "".concat(PREFIX_FOR_TEST_IDS, "-online-database-pub-info-sec-test-id")
};